export enum AuthCookieEnum {
  ACCESS_TOKEN = 'access_token',
  EXPIRES_IN = 'expires_in',
  ID_TOKEN = 'id_token',
  USER_ID = 'user_id',
  TOKEN_TYPE = 'token_type',
}
